import Swal from "sweetalert2/dist/sweetalert2.js";

/*Profile*/
if (window.location.pathname.includes("placement/accounting")) {
  $(window).on("/api/placement/additional_housing.success", (e, response, form) => {
    popup_close("editor-additional_housing");
  });

  $(".table-invoices").data("options", {
    columnDefs: [
      {
        render: function(data, type, row) {
          return "<a href='/placement/edit/" + row.placement_id + "'>" + data + "</a>";
        },
        targets: 0
      },
      {
        render(data, type, row) {
          return `<span class="d-none">${row.start_date}</span>${data}`;
        },
        targets: [6]
      },
      {
        render(data, type, row) {
          return `<span class="invoice-amount" data-value="${window.realFloat(data)}">$${window.formatMoney(data)}</span>`;
        },
        targets: [7]
      },
      {
        render: function(data, type, row) {
          return "<input class='update-invoice' type='text' value='" + data + "' />";
        },
        targets: [8],
        type: "data-sort"
      },
      {
        render: function(data, type, row) {
          const checked = row.paid == 1 ? "checked" : "";
          return "<input class='mark-paid' type='checkbox' " + checked + " />";
        },
        targets: [11]
      },
      {
        render: function(data, type, row) {
          const link = row.pdf_path
            ? `<a href="${window.location.origin +
                "/" +
                row.pdf_path}" target="_blank"><img class="pdf-icon" src="/images/pdf-icon.svg" alt="Download Invoice PDF" /></a>`
            : `<img class="pdf-icon empty" src="/images/pdf-icon.svg" alt="PDF Not Available" />`;

          return `<div class="text-center">${link}</div>`;
        },
        targets: [13]
      }
    ],
    order: [[6, "asc"]]
  });

  $(".table-payments").data("options", {
    columnDefs: [
      {
        render: function(data, type, row) {
          return "<a href='/placement/edit/" + row.placement_id + "'>" + data + "</a>";
        },
        targets: 0
      },
      {
        render(data, type, row) {
          return "$" + window.formatMoney(data);
        },
        targets: 6
      }
    ],
    order: [[3, "asc"]]
  });

  $(".data-table").on("change", ".quickbooks", function() {
    var data = {
      placement: {
        id: $(this).data("placement_id"),
        quickbooks: this.checked ? 1 : 0
      }
    };

    var $this = $(this);

    $.ajax({
      url: "/api/placement/update_quickbooks",
      method: "POST",
      data: data,
      dataType: "json",
      success: function(response) {
        $("[data-placement_id='" + $this.data("placement_id") + "']")
          .not($this)
          .prop("checked", $this.is(":checked"));
      },
      error: function(response) {}
    });
  });

  var timeout;
  $(".data-table").on("keyup", ".update-invoice", function() {
    var ele = $(this);
    clearTimeout(timeout);
    timeout = setTimeout(function() {
      var t = ele.closest(".data-table");
      var td = t
        .DataTable()
        .row(ele.closest("tr")[0])
        .data();
      td["invoice_number"] = ele.val();
      var data = {
        invoice: {
          id: td.id,
          invoice_number: td.invoice_number
        }
      };
      $.ajax({
        url: "/api/invoice/update",
        method: "POST",
        data: data,
        dataType: "json",
        success: function(response) {},
        error: function(response) {}
      });
    }, 500);
  });

  var alert;

  $(window).on("dataTableInit.limelight", function(e, t) {
    $(".data-table").on("click", ".mark-paid", function(e) {
      e.preventDefault();

      if (typeof alert !== "undefined") alert.popover("dispose");

      alert = $(this);

      // Find the corresponding row data
      var t = $(this).closest(".data-table");
      var td = t
        .DataTable()
        .row($(this).closest("tr")[0])
        .data();

      // Set the title based on the paid value
      var popoverTitle = td.paid == 1 ? "Mark as unpaid" : "Mark as paid";

      $(this)
        .popover({
          placement: "left",
          template: popover_templates.confirm,
          title: popoverTitle,
          content: "ARE YOU SURE?",
          delay: { show: 0, hide: 250 }
        })
        .popover("show");
    });
  });

  $(window).on("confirm.bs.popover", function(e, popover, confirm) {
    var ele = $(popover.element);

    if (confirm && ele.hasClass("mark-paid")) {
      var t = ele.closest(".data-table");
      var td = t
        .DataTable()
        .row(ele.closest("tr")[0])
        .data();

      //get todays date
      const today = new Date();
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, "0");
      const day = String(today.getDate()).padStart(2, "0");
      const formattedDate = `${year}-${month}-${day}`;

      // Toggle the paid value and set paid_date accordingly
      var newPaidValue = td.paid == 1 ? 0 : 1;
      var newPaidDate = td.paid_date ? null : formattedDate;
      var data = {
        invoice: {
          id: td.id,
          paid: newPaidValue,
          paid_date: newPaidDate
        }
      };

      $.ajax({
        url: "/api/invoice/update",
        method: "POST",
        data: JSON.stringify(data),
        contentType: "application/json",
        dataType: "json",
        success: function(response) {
          var checkbox = ele.closest("tr").find("input[type='checkbox']");
          if (checkbox.length) {
            var isChecked = checkbox.prop("checked");
            checkbox.prop("checked", !isChecked);
          }
          // Update the row data to reflect the change
          td.paid = newPaidValue;
          td.paid_date = newPaidDate;
          t.DataTable()
            .row(ele.closest("tr")[0])
            .data(td)
            .draw();
        },
        error: function(response) {}
      });
      ele.popover("dispose");
    } else {
      ele.popover("dispose");
    }
  });

  function formatDate(dateObj) {
    return dateObj ? moment(dateObj).format("MM/DD/YYYY") : null;
  }

  // Button action
  $("body").on("click", ".btn-action", function() {
    const data = $(this).data("value");
    data.locked = $(this).data("locked");
    const defaultDate = $(this).data("default-date");
    const activeDate = window.app_data.statusDate;

    Swal.fire({
      title: "Status Report Action",
      html: `<div id="statusAction">
            <v-status-report
              :data="data"
              :default-date="defaultDate"
              :active-date="activeDate"
              :hide-records="true"
            ></v-status-report>
          </div>`,
      icon: undefined,
      showCancelButton: true,
      confirmButtonColor: "#50C3CA",
      showConfirmButton: !data.locked,
      confirmButtonText: data.id === null ? "Submit" : "Update",
      showLoaderOnConfirm: true,
      cancelButtonText: data.locked ? "Close" : "Cancel",
      reverseButtons: true,
      heightAuto: false,
      width: 1024,
      allowOutsideClick: () => !Swal.isLoading(),
      allowEscapeKey: () => !!Swal.isLoading(),
      allowEnterKey: () => !Swal.isLoading(),
      onRender: () => {
        new Vue({
          el: `#statusAction`,
          data: { data: { ...data }, defaultDate, activeDate }
        });
      },
      preConfirm: async () => {
        if (data.locked) return;

        let jsonData = $("#statusForm").serializeArray();
        try {
          let result = await confirmUpdate(jsonData, $(this));
          return result;
        } catch (e) {
          Swal.showValidationMessage(`There is something wrong!`);
        }
      },
      onClose: () => {
        $('#statusForm input[name="color_code"]').val("");
        $("#statusForm").off("click", ".colorpicker");
        $(".colorpicker-palette").off("click", ".colorpicker-wrapper");
        $(".colorpicker-palette").hide();
      }
    }).then(result => {
      if (result.isConfirmed) {
        Swal.fire("Updated", "The placement status data has updated.", "success");
      }
    });
  });

  // Button track
  $("body").on("click", ".btn-tracking", function() {
    $(".table-trackings-tables").slideToggle();
  });

  function confirmUpdate(data, $this) {
    return new Promise((resolve, reject) => {
      $.ajax({
        url: "/api/placement_status/create",
        method: "POST",
        data: data,
        dataType: "json",
        success: function(response) {
          const status = response["updated"] || response["placement_status"];
          if (!status) return resolve(response);

          const index = window.app_data.properties_data.findIndex(d => d.property.id == status["property_id"]);
          window.app_data.properties_data[index].statuses = window.app_data.properties_data[index].statuses.map(item => {
            if (item.id == status["id"]) {
              item["paid_at"] = status["paid_at"];
              item["invoiced_at"] = status["invoiced_at"];
              item["pay_amount"] = status["pay_amount"];
              item["invoice_amount"] = status["invoice_amount"];
              item["prepaid_through"] = formatDate(status["prepaid_through"]);
              item["paid_start_date"] = formatDate(status["paid_start_date"]);
              item["paid_end_date"] = formatDate(status["paid_end_date"]);
              item["paid_notes"] = status["paid_notes"];
              item["invoiced_notes"] = status["invoiced_notes"];
              item["invoiced_start_date"] = formatDate(status["invoiced_start_date"]);
              item["invoiced_end_date"] = formatDate(status["invoiced_end_date"]);
              item["color_code"] = status["color_code"];
              item["insurance_approved_extension_date"] = formatDate(status["insurance_approved_extension_date"]);
              item["total_invoices"] = status["total_invoices"];
              item["total_payables"] = status["total_payables"];
              item["invoices"] = status["invoices"];
              item["payables"] = status["payables"];
              item["status_notes"] = status["status_notes"];
              item["note"] = status["note"];

              $this
                .closest("tr")
                .find(".btn-action")
                .data("value", item);

              return item;
            } else if (item.placement_id == status["placement_id"] && item.property_id == status["property_id"]) {
              item["id"] = status["id"];
              item["paid_at"] = status["paid_at"];
              item["invoiced_at"] = status["invoiced_at"];
              item["pay_amount"] = status["pay_amount"];
              item["invoice_amount"] = status["invoice_amount"];
              item["prepaid_through"] = formatDate(status["prepaid_through"]);
              item["paid_start_date"] = formatDate(status["paid_start_date"]);
              item["paid_end_date"] = formatDate(status["paid_end_date"]);
              item["paid_notes"] = status["paid_notes"];
              item["invoiced_notes"] = status["invoiced_notes"];
              item["invoiced_start_date"] = formatDate(status["invoiced_start_date"]);
              item["invoiced_end_date"] = formatDate(status["invoiced_end_date"]);
              item["color_code"] = status["color_code"];
              item["insurance_approved_extension_date"] = formatDate(status["insurance_approved_extension_date"]);
              item["total_invoices"] = status["total_invoices"];
              item["total_payables"] = status["total_payables"];
              item["invoices"] = status["invoices"];
              item["payables"] = status["payables"];
              item["note"] = status["note"];

              $this
                .closest("tr")
                .find(".btn-action")
                .data("value", item);

              return item;
            }

            if (item.placement_id == status["placement_id"]) {
              item["status_notes"] = status["status_notes"];
            }

            return item;
          });

          resolve(response);
        },
        error: function(response) {
          reject(response);
        }
      });
    });
  }

  $("body").on("click", ".payable-to-details", function() {
    const email = $(this).data("email");
    const phone = $(this).data("phone");

    Swal.fire({
      title: "Contact Details",
      html: `<div class="text-left">
        <p class="mb-0"><strong>Email:</strong> ${email ? `<a href="mailto:${email}">${email}</a>` : "N/A"}</p>
        <p class="mb-0"><strong>Phone:</strong> ${phone ? `<a href="tel:${phone}">${phone}</a>` : "N/A"}</p>
      </div>`,
      icon: undefined,
      showConfirmButton: false,
      showCancelButton: true,
      heightAuto: false,
      cancelButtonText: "Close"
    });
  });
}



// WEBPACK FOOTER //
// ./resources/assets/js/pages/accounting.js